<template>
  <!-- 14-2 教育机构收藏医疗机构列表 -->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("favoriteMedical") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleDeleteClick">{{
          $t("delete")
        }}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          ref="multipleTable"
          @row-click="qaq"
          :data="tableData"
          style="width: 98%"
          :max-height="tableHeight"
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
          v-loading="loading"
        >
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------機関番号---------------------- -->
          <el-table-column
            prop="medicalId"
            label="機関番号"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicId") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.medicalId }}
            </template>
          </el-table-column>
          <!-- ----------------------医療機関名---------------------- -->
          <el-table-column
            prop="medicalName"
            label="医療機関名"
            min-width="110"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.medicalName }}
            </template>
          </el-table-column>

          <!-- ----------------------所在地---------------------- -->
          <el-table-column
            prop="address"
            label="所在地"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("location") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.address }}
            </template>
          </el-table-column>
          <!-- ----------------------代表者---------------------- -->
          <el-table-column
            prop="legalPerson"
            label="代表者"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("representativeName") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.legalPerson }}
            </template>
          </el-table-column>
          <!-- ----------------------機関属性---------------------- -->
          <el-table-column
            prop="attributes"
            label="機関属性"
            :sortable="'custom'"
            width="220px"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("institutionalAttributes") }}</p>
              <el-dropdown @command="handleClickOne">
                <span class="el-dropdown-link">
                  {{ medicalAttributes
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in userTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpattributes_dictText
              }}</span>
              <span v-else>{{ scope.row.attributes_dictText }}</span>
            </template>
          </el-table-column>

          <!-- ----------------------ベット数---------------------- -->
          <el-table-column
            prop="bedNumber"
            label="ベット数"
            :sortable="'custom'"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("numberOfBets") }}</p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpbedNumber_dictText
              }}</span>
              <span v-else>{{ scope.row.bedNumber_dictText }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------求人案件数---------------------- -->
          <el-table-column
            prop="casesNumber"
            label="求人案件数"
            :sortable="'custom'"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("jobCaseNumber") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.casesNumber }}
            </template>
          </el-table-column>
          <!-- ----------------------観覧回数---------------------- -->
          <el-table-column
            prop="browseNumber"
            label="観覧回数"
            :sortable="'custom'"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.browseNumber }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalItem"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  deleteMedicalCollect,
  deleteMedicalCollectionEducation,
  fuzzySelectMedicalInstitutionCollect,
  queryFuzzyMedicalCollectioneducation,
  queryMedicalCollectioneducation,
  selectMedicalInstitutionCollect
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "educationalInstitutionCollectionMedicalInstitutionList",
  components: {},
  data() {
    return {
      idList: [],
      inputData1: "", //搜索框input内容
      tableData: [{}], //   table内容
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      dialogIsShow: false, //dialog弹窗标识
      totalItem: 0,
      language: "",
      userTableData: [],
      medicalAttributes: "ALL",
      medicalAttributescode: "",
      tableHeight: "" //表格高度
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.userRights();
    this.findAllMedical();
    this.getTableHeight();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    } //搜索部分的placeholder
  },
  methods: {
    //获取表格高度
    getTableHeight() {
      let tableH = 330; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据7------");
      console.log(e);
      this.tableData = [];
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.userRights();
        that.findAllMedical();
      }
    },
    //获取下拉框选项
    userRights() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpmedicalAttributes";
      } else {
        dataItems = "medicalAttributes";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res, "获取下拉框选项获取下拉框选项获取下拉框选项");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.userTableData = aesFecInfo.data;
            that.userTableData.push({
              code: "",
              dictCode: "jpmedicalAttributes",
              name: that.$t("allName")
            });
            console.log(that.userTableData, this.$t("allName"));
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    qaq(row, event, column) {
      this.$router.push({
        name: "educationViewMedicalHomepage",
        query: { medicalId: row.medicalId }
      });
      console.log(row);
    },
    //选择行数据
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].medicalId);
      }
      console.log(this.idList);
      this.stateChange = val;
    },
    //收藏医疗机构删除接口
    handleDeleteClick() {
      console.log("- お気に入りから削除 button");
      if (this.idList.length < 1) {
        this.$message({
          message: "请选择至少一条信息!",
          type: "warning"
        });
      } else {
        console.log(this.idList);
        const jobListIdDTO = {
          // "listId": [],
          listId: this.idList
        };
        deleteMedicalCollect(jobListIdDTO)
          .then(res => {
            console.log("-----收藏医疗机构删除接口-----");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$message({
                message: "取消收藏成功!",
                type: "success"
              });
              this.findAllMedical();
            } else {
              this.$message.error("取消收藏失败");
            }
          })
          .catch(res => {
            console.log("-----医疗机构-----");
            console.log(res);
          });
      }
    },
    //收藏列表医疗机构模糊查询接口
    FuzzyQuery() {
      var fakeInfo = {
        address: this.searchData3,
        attributes: this.medicalAttributescode,
        legalPerson: this.searchData4,
        medicalId: this.searchData1,
        medicalName: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      fuzzySelectMedicalInstitutionCollect(fakeInfo)
        .then(res => {
          console.log("-----医疗机构收藏教育机构模糊查询-----");
          console.log(res);
          if (res.data.code == "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalItem = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          } else {
            this.$message.error("查询失败。");
          }
        })
        .catch(res => {});
    },
    //收藏列表医疗机构查询接口
    findAllMedical(e) {
      console.log("＋查询");
      var fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      selectMedicalInstitutionCollect(fakeInfo)
        .then(res => {
          console.log("--------收藏列表医疗机构查询接口--------");
          console.log(res);
          if (res.data.code == "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalItem = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          } else {
            this.$message.error("查询失败。");
          }
        })
        .catch(res => {});
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "bedNumber") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["bedNumber"] - b["bedNumber"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["bedNumber"] - a["bedNumber"]
          );
        }
      } else if (column.prop === "caseNumber") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["caseNumber"] - b["caseNumber"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["caseNumber"] - a["caseNumber"]
          );
        }
      } else if (column.prop === "watchNumber") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["watchNumber"] - b["watchNumber"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["watchNumber"] - a["watchNumber"]
          );
        }
      }
    },

    //分页
    handleCurrentChange(evt) {
      this.currentPage = evt;
      console.log(this.currentPage);
      this.findAllMedical();
    },
    //每页下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.findAllMedical();
    },

    //下拉框
    handleClickOne(e) {
      this.medicalAttributescode = e.code;
      this.medicalAttributes = e.name;
      console.log(this.medicalAttributes);
      console.log(e);
      this.FuzzyQuery();
    },
    //状态筛选
    handleClickTwo(val) {
      if (val === "a") {
        console.log("公開中");
      } else if (val === "b") {
        console.log("关闭");
      }
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 40px;
  box-sizing: border-box;
}
.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
  margin-top: 10px;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}
.button-css {
  width: 150px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  width: 100%;
  margin-top: 10px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}
.operate {
  height: 51px;
}
.table /deep/ .el-dropdown {
  /* width: 60px; */
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: -40px;
  width: 67px;
}
.pagination {
  width: 98%;
  height: 50px;
  margin-top: 10px;
}
.pagination-main {
  float: right;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationalInstitutionCollectionMedicalInstitutionList/index.vue